import Donut from './Donut/Donut';
import Bar from './Bar/Bar';
import Recommendation from './Recommendation';
import IPS from './IPS';
import ExistingPolicyAnalysis from './ExistingPolicyAnalysis';
import RiskAnalysis from './RiskAnalysis';
import RiskSummaary from './RiskSummary';
import InvestmentAnalyser from './InvestmentAnalyser';
import MorningstarRiskProfiler from './MorningstarRiskProfiler';

export default {
  Donut,
  Bar,
  Recommendation,
  IPS,
  ExistingPolicyAnalysis,
  RiskAnalysis,
  RiskSummaary,
  InvestmentAnalyser,
  MorningstarRiskProfiler
};
